import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import toast from "react-hot-toast";
import Select from "react-select";
import PrimaryButton from "../../../components/PrimaryButton";
import "./accountDetailTabs.css";

function AccountTab({ formData, handleRefresh }) {
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [claim_business, setClaim_business] = useState([]);
  const [OpenClaimModel, setOpenClaimModel] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [consumerOptions, setConsumerOptions] = useState([]);
  const [selectedConsumer, setSelectedConsumer] = useState(null);
  const [consumer, setConsumer] = useState([]);
  const [consumerLoader, setConsumerLoader] = useState(true);

  const getClaimBusiness = async () => {
    if (!formData?.id) return;

    const { response } = await AppService.claim_business.Get({
      query: `business_id=${formData.id}&status=approved`,
    });

    if (response) {
      setClaim_business(response.data);
    }
  };

  useEffect(() => {
    getClaimBusiness();
  }, [formData]);

  const handleUnclaim = async (id, type) => {
    const payload = {
      _id: id,
      type,
    };

    const { response } = await AppService.claim_business.unClaimListing({ payload });

    if (response) {
      getClaimBusiness();
    }
  };

  const tableTHStyles = {
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    fontWeight: 700,
    fontSize: 13,
    color: "#475467",
  };

  const onLoad = async () => {
    try {
      const { response } = await AppService.accounts.GetAccountsForAgency({
        query: `agency_id=${agency._id}&tags=consumer`,
        toaster: false,
      });

      if (response) {
        const formattedConsumers = (response?.data || []).map((item) => ({
          label:
            [item.first_name, item.last_name].filter(Boolean).join(" ") || item.email || "Unknown",
          value: item.id,
        }));

        setConsumerOptions(formattedConsumers);
        setConsumer(response?.data || []);
      } else {
        setConsumerOptions([]);
      }
    } catch (error) {
      console.log(error);
      setConsumerOptions([]);
    } finally {
      setConsumerLoader(false);
    }
  };

  const selectedoption = consumer?.find((item) => item?.id === selectedConsumer?.value) || null;

  const handleAssignConsumer = async () => {
    if (!selectedConsumer) return;
    try {
      const payload = {
        business_id: formData?.id,
        business_ref_id: formData?._id,
        account_id: selectedoption.id,
        agency_id: agency?._id,
        address: formData?.address,
        business_name: formData?.business_name || formData?.first_name,
        business_reference: formData?.business_name || formData?.first_name,
        email: selectedoption?.email || "",
        phone: formData?.phone,
        first_name: selectedoption?.first_name,
        last_name: selectedoption?.last_name,
        request_type: "claim",
        role: "Owner",
        status: "approved",
      };
      const { response } = await AppService.claim_business.AssignConsumer({ payload });
      if (response) {
        setSelectedConsumer(null);
        toast.success("Consumer assigned successfully");
        handleRefresh();
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to assign consumer");
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const styles = {
    container: {
      width: "100%",
      maxWidth: "500px",
      marginBottom: "30px",
    },
    label: {
      marginBottom: "6px",
      display: "block",
      fontWeight: 500,
      fontSize: "13px",
      color: "#374151",
    },
    row: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginTop: "8px",
    },
    selectWrapper: {
      width: "320px",
    },
  };

  return (
    <div className="sd-account-detail-tab">
      <>
      <div style={styles.container}>
        <label style={styles.label}>Assign Consumer</label>

        <div style={styles.row}>
          <div style={styles.selectWrapper}>
            <Select
              options={consumerOptions}
              value={selectedConsumer}
              onChange={(selected) => setSelectedConsumer(selected)}
              isLoading={consumerLoader}
              placeholder="Select a consumer..."
              isClearable
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: "38px",
                  fontSize: "13px",
                  borderRadius: "8px",
                  borderColor: state.isFocused ? "#2563eb" : "#d1d5db",
                  boxShadow: state.isFocused ? "0 0 0 1px #2563eb" : "none",
                  "&:hover": {
                    borderColor: "#2563eb",
                  },
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>

          <PrimaryButton type="button" onClick={handleAssignConsumer} disabled={!selectedConsumer}>
            Assign
          </PrimaryButton>
        </div>
      </div>
      <div>
        <p className="text-center">{success}</p>
        {/* table where show name, content, and rating */}
        <SoftBox>
          <div className="overflow-x-auto">
            <table className="table w-100" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      borderBottomLeftRadius: "18px",
                      borderTopLeftRadius: "18px",
                    }}
                  >
                    Name
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                    }}
                  >
                    Email
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      borderBottomRightRadius: "18px",
                      borderTopRightRadius: "18px",
                    }}
                  >
                    Un claim
                  </th>
                </tr>
              </thead>
              <tbody>
                {claim_business.map((review) => (
                  <tr
                    key={review._id}
                    style={{ cursor: "pointer", borderBottom: "1px solid #DDDDDD" }}
                  >
                    <td className="p-20-px">{`${review.first_name} ${review.last_name}`}</td>
                    <td className="p-20-px">{review.email}</td>
                    <td className="p-20-px" style={{ display: "flex", gap: "10px" }}>
                      <PrimaryButton
                        type="button"
                        className="sd-primary-btn--dark"
                        onClick={() => {
                          setSelectedId(review._id);
                          setActionType("status");
                          setOpenClaimModel(true);
                        }}
                      >
                        Unclaim
                      </PrimaryButton>
                      {/* <button
                      onClick={() => {
                        setSelectedId(review._id);
                        setActionType("delete");
                        setOpenClaimModel(true);
                      }}
                      style={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        backgroundColor: "#ef4444",
                        color: "#ffffff",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Delete Claim
                    </button> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {OpenClaimModel && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: "360px",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  padding: "20px",
                  textAlign: "center",
                }}
              >
                <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>Confirm Action</h3>

                <p style={{ fontSize: "14px", marginBottom: "20px", color: "#555" }}>
                  {actionType === "delete"
                    ? "Are you sure you want to delete this claim? This action cannot be undone."
                    : "Are you sure you want to unclaim this business?"}
                </p>

                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <PrimaryButton
                    type="button"
                    className="sd-primary-btn--outline"
                    onClick={() => setOpenClaimModel(false)}
                  >
                    Cancel
                  </PrimaryButton>

                  <PrimaryButton
                    type="button"
                    className="sd-primary-btn--dark"
                    onClick={() => {
                      handleUnclaim(selectedId, actionType);
                      setOpenClaimModel(false);
                    }}
                  >
                    {actionType === "delete" ? "Delete" : "Unclaim"}
                  </PrimaryButton>
                </div>
              </div>
            </div>
          )}
        </SoftBox>
      </div>
      </>
    </div>
  );
}

export default AccountTab;

